import AllVariables from "./AllVariables";

export default AllVariables;